exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".changed[data-v-f2c2adaa]{font-weight:700;animation:blinker-data-v-f2c2adaa 1s linear infinite}@keyframes blinker-data-v-f2c2adaa{0%{opacity:0}50%{opacity:.5}to{opacity:1}}.highlight[data-v-f2c2adaa]{background-color:rgba(190,30,30,.68)!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f2c2adaa","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Watch/WatchList.vue
// module id = 210
// module chunks = 0